module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-2"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "fullscreen"
    },
    model: {
      value: (_vm.isModalExportar),
      callback: function($$v) {
        _vm.isModalExportar = $$v
      },
      expression: "isModalExportar"
    }
  }, [(_vm.isModalExportar) ? _c('parametros-exportacion', {
    attrs: {
      "id": _vm.idReporteExportar,
      "preview": "save"
    },
    on: {
      "close": _vm.closeDialogExportar
    }
  }) : _vm._e()], 1), _c('v-dialog', {
    attrs: {
      "max-width": "350"
    },
    model: {
      value: (_vm.isModalEliminar),
      callback: function($$v) {
        _vm.isModalEliminar = $$v
      },
      expression: "isModalEliminar"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('strong', {
    staticClass: "font-size-17"
  }, [_vm._v("¿Realmente deseas eliminar el reporte"), _c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("  " + _vm._s(_vm.reporteAEliminar.titulo) + "?")])]), _c('v-card-text', {
    staticClass: "mt-4 px-0"
  }, [_c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Si continuas con este proceso el reporte se eliminará permanentemente y no se podra recuperar")])]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "color": "ligth",
      "small": "small"
    },
    on: {
      "click": _vm.closeDialogEliminar
    }
  }, [_vm._v("cancelar")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchEliminarReporte()
      }
    }
  }, [_vm._v("Eliminar")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": "400"
    },
    model: {
      value: (_vm.isModalGuardarReporte),
      callback: function($$v) {
        _vm.isModalGuardarReporte = $$v
      },
      expression: "isModalGuardarReporte"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Nuevo reporte")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-13"
  }, [_vm._v("Los filtros asignados a este nuevo reporte serán los parametros de tipo"), _c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("  " + _vm._s(_vm.tiposReporte[_vm.indexReporte].name))])])], 1), _c('v-text-field', {
    ref: "tituloModal",
    staticClass: "pa-4 pb-0",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "label": "Titulo  "
    },
    model: {
      value: (_vm.query.titulo),
      callback: function($$v) {
        _vm.$set(_vm.query, "titulo", $$v)
      },
      expression: "query.titulo"
    }
  }), _c('v-text-field', {
    staticClass: "pa-4 pb-0",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "label": "Descripcion del resultado "
    },
    model: {
      value: (_vm.query.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.query, "descripcion", $$v)
      },
      expression: "query.descripcion"
    }
  }), _c('v-card-actions', {
    staticClass: "mt-8"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "color": "ligth",
      "small": "small"
    },
    on: {
      "click": _vm.closeModalGuardarReporte
    }
  }, [_vm._v("  cancelar")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardarReporte()
      }
    }
  }, [_vm._v("  Generar reporte")])], 1)], 1)], 1), _c('v-card', {
    staticClass: "mx-auto elevation-1"
  }, [_c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("  Generador de reportes")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-13"
  }, [_vm._v("  Crea, guarda y exporta tus reportes")])], 1)]), _c('v-divider'), (_vm.isMovil) ? _c('v-tabs', {
    staticClass: "elevation-1 position-sticky",
    attrs: {
      "fixed-tabs": ""
    }
  }, [_c('v-tab', {
    on: {
      "click": function($event) {
        _vm.tabActive = 1
      }
    }
  }, [_c('small', [_vm._v("Listado Reportes")])]), _c('v-tab', {
    on: {
      "click": function($event) {
        _vm.tabActive = 2
      }
    }
  }, [_c('small', [_vm._v("Parametros")])])], 1) : _vm._e(), _c('v-sheet', {
    staticClass: "pa-3"
  }, [_c('v-row', [(!_vm.isMovil || _vm.isMovil && _vm.tabActive === 1) ? _c('v-col', {
    staticClass: "b-right",
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    staticClass: "mb-3",
    attrs: {
      "items": _vm.tiposListados,
      "hide-details": "hide-details",
      "label": "Tipo Listado",
      "dense": "",
      "solo": "",
      "item-value": "id",
      "item-text": "name"
    },
    on: {
      "change": function($event) {
        _vm.definirNuevoReporte(), _vm.fetchObtenerListadoReportes(null)
      }
    },
    model: {
      value: (_vm.indexTipoListadoReportes),
      callback: function($$v) {
        _vm.indexTipoListadoReportes = $$v
      },
      expression: "indexTipoListadoReportes"
    }
  }), _c('v-btn', {
    staticClass: "mb-3",
    attrs: {
      "block": "block",
      "color": "success",
      "disabled": _vm.indexTipoListadoReportes === 1
    },
    on: {
      "click": function($event) {
        return _vm.definirNuevoReporte()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("add_circle")]), _vm._v(" reporte en blanco")], 1), _c('v-card', {
    staticClass: "overflow-y-auto elevation-0 px-1",
    attrs: {
      "max-height": "calc(100vh - 251px)"
    }
  }, _vm._l((_vm.listado), function(item, i) {
    return _c('v-card', {
      key: i,
      staticClass: "pa-0 my-2 elevation-1",
      attrs: {
        "nav": "",
        "dark": _vm.idReporteSeleccionado === item.id,
        "dense": "",
        "color": _vm.idReporteSeleccionado === item.id ? 'primary' : ''
      },
      on: {
        "dblclick": function($event) {
          return _vm.goToPrevisualizarReporte(item.id, item.esReporteDefinido)
        }
      }
    }, [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.editarReporte(item, item.id)
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', {
      staticClass: "font-size-13"
    }, [_c('span', {
      staticClass: "font-weight-700"
    }, [_vm._v(_vm._s(item.titulo))])]), _c('v-list-item-subtitle', {
      staticClass: "font-size-11"
    }, [_vm._v(_vm._s(item.descripcion ? item.descripcion : 'No cuenta con subtitulo'))]), _c('div', {
      staticClass: "d-flex ai-center mt-1"
    }, [_c('v-chip', {
      staticClass: "mr-1",
      attrs: {
        "x-small": "x-small",
        "color": _vm.idReporteSeleccionado === item.id ? 'white primary--text' : 'primary'
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "8"
      }
    }, [_vm._v("circle")]), _c('span', {
      staticClass: "font-weight-700 font-size-11"
    }, [_vm._v(_vm._s(item.tipo))])], 1), _c('v-spacer'), _c('small', {
      staticClass: "font-size-10 text-muted"
    }, [_vm._v("fue creado  " + _vm._s(_vm._f("now")(item.fechaRegistro)))])], 1)], 1), _c('v-list-item-action', {
      staticClass: "ma-0"
    }, [_c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "icon": "icon"
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("more_vert")])], 1)]
        }
      }], null, true)
    }, [_c('v-list', {
      attrs: {
        "dense": "dense"
      }
    }, [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.goToPrevisualizarReporte(item.id, item.esReporteDefinido)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Visualizar resultados")])], 1), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.openDialogExportar(item.id)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Exportar resultados")])], 1), (!item.esReporteDefinido) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.openDialogEliminar(item)
        }
      }
    }, [_c('v-list-item-title', {
      staticClass: "primary--text"
    }, [_vm._v("Eliminar permanentemente")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
  }), 1)], 1) : _vm._e(), (!_vm.isMovil || _vm.isMovil && _vm.tabActive === 2) ? _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "12",
      "sm": "9"
    }
  }, [_c('div', {
    staticClass: "d-flex ai-center flex-1 pa-4"
  }, _vm._l((_vm.tiposReporte), function(r, index) {
    return _c('v-card', {
      key: index,
      staticClass: "pa-2",
      class: {
        'mr-4': index < _vm.tiposReporte.length - 1
      },
      attrs: {
        "name": index,
        "id": _vm.tiposReporte.length - 1,
        "color": r.id === _vm.indexReporte ? 'primary white--text' : '',
        "width": _vm.isMovil ? '' : 200,
        "height": "70",
        "hover": "hover",
        "disabled": _vm.indexTipoListadoReportes === 1
      },
      on: {
        "click": function($event) {
          return _vm.seleccionarTipoReporte(r.id)
        }
      }
    }, [_c('div', {
      staticClass: "d-flex ai-center"
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "40",
        "color": r.id === _vm.indexReporte ? 'white' : 'background'
      }
    }, [_vm._v(_vm._s(r.icon))]), _c('div', {
      staticClass: "flex-1 d-flex fd-column"
    }, [_c('span', {
      staticClass: "font-weight-700 font-size-20",
      class: {
        'font-size-17': _vm.isMovil
      }
    }, [_vm._v(_vm._s(r.name))]), _c('small', {
      staticClass: "font-size-11",
      class: {
        'white--text': r.id === _vm.indexReporte
      }
    }, [_vm._v(_vm._s(r.description))])])], 1)])
  }), 1), (_vm.idReporteSeleccionado !== '') ? _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('v-text-field', {
    ref: "tituloCreado",
    staticClass: "pa-4 pb-0",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "label": "Titulo  ",
      "disabled": _vm.indexTipoListadoReportes === 1
    },
    model: {
      value: (_vm.query.titulo),
      callback: function($$v) {
        _vm.$set(_vm.query, "titulo", $$v)
      },
      expression: "query.titulo"
    }
  }), _c('v-text-field', {
    staticClass: "pa-4 pb-0",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "label": "Descripcion del resultado",
      "disabled": _vm.indexTipoListadoReportes === 1
    },
    model: {
      value: (_vm.query.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.query, "descripcion", $$v)
      },
      expression: "query.descripcion"
    }
  })], 1) : _vm._e(), _c('v-card-title', [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Asignación de parametros")])]), _c('v-card', {
    staticClass: "elevation-0 pa-3 overflow-y-auto pt-0",
    attrs: {
      "height": _vm.idReporteSeleccionado !== '' ? 'calc(100vh - 455px)' : 'calc(100vh - 364px)'
    }
  }, [(_vm.indexReporte === 0) ? [_c('v-text-field', {
    staticClass: "pb-3",
    attrs: {
      "label": "Numero de ticket",
      "persistent-hint": "persistent-hint",
      "hint": "Si usas este filtro, los demas parametros no se tomarán en cuenta",
      "type": "number"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.query.numero),
      callback: function($$v) {
        _vm.$set(_vm.query, "numero", $$v)
      },
      expression: "query.numero"
    }
  }), _c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v("Tipo")]), _c('v-radio-group', {
    staticClass: "pt-1 mt-1",
    attrs: {
      "hide-details": "hide-details"
    },
    on: {
      "change": function($event) {
        return _vm.reRenderEstados()
      }
    },
    model: {
      value: (_vm.query.tipo),
      callback: function($$v) {
        _vm.$set(_vm.query, "tipo", $$v)
      },
      expression: "query.tipo"
    }
  }, [_c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "incidencia con equipo"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.tipo === 'incidencia con equipo'
          }
        }, [_vm._v(" Incidencia con equipo - contrato")])]
      },
      proxy: true
    }], null, false, 3384785156)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "solicitud de insumo"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.tipo === 'solicitud de insumo'
          }
        }, [_vm._v(" Solicitud de insumo - contrato")])]
      },
      proxy: true
    }], null, false, 2466712196)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "garantia"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.tipo === 'garantia'
          }
        }, [_vm._v(" Garantia")])]
      },
      proxy: true
    }], null, false, 4089655639)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "-1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.tipo === '-1'
          }
        }, [_vm._v(" Todos")])]
      },
      proxy: true
    }], null, false, 1418143112)
  })], 1)], 1)]), _c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v("Mostrar")]), _c('v-radio-group', {
    staticClass: "pt-1 mt-1",
    attrs: {
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.query.abierto),
      callback: function($$v) {
        _vm.$set(_vm.query, "abierto", $$v)
      },
      expression: "query.abierto"
    }
  }, [_c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.abierto === '1'
          }
        }, [_vm._v(" Abiertos")])]
      },
      proxy: true
    }], null, false, 2416177943)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "0"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.abierto === '0'
          }
        }, [_vm._v(" Cerrados")])]
      },
      proxy: true
    }], null, false, 403681116)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "-1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.abierto === '-1'
          }
        }, [_vm._v(" Todos")])]
      },
      proxy: true
    }], null, false, 2199221100)
  })], 1)], 1)]), _c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v("Area")]), _c('v-radio-group', {
    staticClass: "pt-1 mt-1",
    attrs: {
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.query.area),
      callback: function($$v) {
        _vm.$set(_vm.query, "area", $$v)
      },
      expression: "query.area"
    }
  }, [_c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "campo"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.area === 'campo'
          }
        }, [_vm._v(" Campo")])]
      },
      proxy: true
    }], null, false, 808990114)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "taller"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.area === 'taller'
          }
        }, [_vm._v(" Taller")])]
      },
      proxy: true
    }], null, false, 2827400834)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "sin asignacion"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.area === 'sin asignacion'
          }
        }, [_vm._v("Sin asignacion")])]
      },
      proxy: true
    }], null, false, 3402295298)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "-1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.area === '-1'
          }
        }, [_vm._v("Todos")])]
      },
      proxy: true
    }], null, false, 3560182205)
  })], 1)], 1)])]), (_vm.showFiltroEstados && _vm.query.tipo !== '-1') ? _c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v("Estados")]), _c('estados-ticket', {
    staticClass: "pt-1",
    attrs: {
      "tipo": _vm.query.tipo,
      "show-clear": "show-clear",
      "codigo": _vm.query.estado
    },
    on: {
      "selected": _vm.obtenerEstado
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v("Rango de fechas")]), _c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1 mr-2"
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Desde ",
      "type": "date"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.query.desde),
      callback: function($$v) {
        _vm.$set(_vm.query, "desde", $$v)
      },
      expression: "query.desde"
    }
  })], 1), _c('div', {
    staticClass: "flex-1",
    class: {
      'ml-2': !_vm.isMovil
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Hasta ",
      "type": "date"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.query.hasta),
      callback: function($$v) {
        _vm.$set(_vm.query, "hasta", $$v)
      },
      expression: "query.hasta"
    }
  })], 1)])]), _c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v("Especifico")]), _c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1 mr-2"
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Codigo de cliente - interno/sap",
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.query.codigoCliente),
      callback: function($$v) {
        _vm.$set(_vm.query, "codigoCliente", $$v)
      },
      expression: "query.codigoCliente"
    }
  })], 1), _c('div', {
    staticClass: "flex-1",
    class: {
      'ml-2': !_vm.isMovil
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Serie",
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.query.serie),
      callback: function($$v) {
        _vm.$set(_vm.query, "serie", $$v)
      },
      expression: "query.serie"
    }
  })], 1), _c('div', {
    staticClass: "flex-1",
    class: {
      'ml-2': !_vm.isMovil
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Modelo",
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.query.modelo),
      callback: function($$v) {
        _vm.$set(_vm.query, "modelo", $$v)
      },
      expression: "query.modelo"
    }
  })], 1)])]), (_vm.query.tipo === 'garantia') ? _c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v("Zona de asignacion")]), _c('v-radio-group', {
    staticClass: "pt-1 mt-1",
    attrs: {
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.query.zona),
      callback: function($$v) {
        _vm.$set(_vm.query, "zona", $$v)
      },
      expression: "query.zona"
    }
  }, [_c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "lima"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.zona === 'lima'
          }
        }, [_vm._v(" Lima")])]
      },
      proxy: true
    }], null, false, 3720450511)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "arequipa"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.zona === 'arequipa'
          }
        }, [_vm._v(" Arequipa")])]
      },
      proxy: true
    }], null, false, 2978491343)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "sin asignacion"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.zona === 'sin asignacion'
          }
        }, [_vm._v(" Sin asignacion")])]
      },
      proxy: true
    }], null, false, 2245825615)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "-1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.zona === '-1'
          }
        }, [_vm._v(" Todos")])]
      },
      proxy: true
    }], null, false, 4093891856)
  })], 1)], 1)]), _c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "d-flex py-2 fd-column"
  }, [_c('strong', {
    staticClass: "font-size-12"
  }, [_vm._v(" ¿Ingresaron a taller?")]), _c('v-radio-group', {
    staticClass: "pt-1 mt-1",
    attrs: {
      "hide-details": "hide-details"
    },
    model: {
      value: (_vm.query.ingresoATaller),
      callback: function($$v) {
        _vm.$set(_vm.query, "ingresoATaller", $$v)
      },
      expression: "query.ingresoATaller"
    }
  }, [_c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.ingresoATaller === '1'
          }
        }, [_vm._v(" Si")])]
      },
      proxy: true
    }], null, false, 4020795862)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "0"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.ingresoATaller === '0'
          }
        }, [_vm._v(" No")])]
      },
      proxy: true
    }], null, false, 1875698668)
  }), _c('v-radio', {
    staticClass: "flex-1",
    attrs: {
      "value": "-1"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('strong', {
          class: {
            'primary--text': _vm.query.ingresoATaller === '-1'
          }
        }, [_vm._v(" Todos")])]
      },
      proxy: true
    }], null, false, 120740770)
  })], 1)], 1)])]) : _vm._e()] : _vm._e(), (_vm.indexReporte === 1) ? [(_vm.indexTipoListadoReportes === 0) ? _c('v-row', {
    staticClass: "pt-1",
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "hide-details",
      "items": _vm.columnasTicket,
      "return-object": "return-object",
      "item-value": "valor",
      "item-text": "nombre",
      "loading": _vm.isLoadingColumsTickets,
      "label": "Seleccionar campo",
      "dense": "",
      "solo": ""
    },
    on: {
      "change": _vm.validarDataType
    },
    model: {
      value: (_vm.reporteAvanzado.campo),
      callback: function($$v) {
        _vm.$set(_vm.reporteAvanzado, "campo", $$v)
      },
      expression: "reporteAvanzado.campo"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "hide-details",
      "items": _vm.itemsCondiciones,
      "return-object": "return-object",
      "item-value": "valor",
      "item-text": "name",
      "label": "Criterios",
      "dense": "",
      "solo": ""
    },
    model: {
      value: (_vm.reporteAvanzado.criterio),
      callback: function($$v) {
        _vm.$set(_vm.reporteAvanzado, "criterio", $$v)
      },
      expression: "reporteAvanzado.criterio"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "hide-details",
      "label": "Valor",
      "dense": "dense",
      "type": _vm.valorType,
      "solo": "solo"
    },
    model: {
      value: (_vm.reporteAvanzado.valor),
      callback: function($$v) {
        _vm.$set(_vm.reporteAvanzado, "valor", $$v)
      },
      expression: "reporteAvanzado.valor"
    }
  }), (Object.keys(_vm.reporteAvanzado.campo).length) ? _c('small', {
    staticClass: "font-size-11"
  }, [_vm._v("Valor aceptado:  "), _c('strong', [_vm._v(_vm._s(_vm.reporteAvanzado.campo.descripcionType))])]) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "block",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.agregarQueryAvanzado()
      }
    }
  }, [_vm._v("Agregar")])], 1)], 1) : _vm._e(), _c('v-data-table', {
    staticClass: "elevation-0 mt-8",
    attrs: {
      "headers": _vm.headersFiltrosAvanzados,
      "items": _vm.queryAvanzados,
      "dense": "dense",
      "disable-pagination": true,
      "hide-default-footer": "hide-default-footer"
    },
    scopedSlots: _vm._u([{
      key: "item.columna",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', [_vm._v(_vm._s(item.columna.nombre))])]
      }
    }, {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('div', {
          staticClass: "d-flex ai-center",
          class: {
            'ma-1': !_vm.isMovil
          }
        }, [_c('v-btn', {
          staticClass: "mr-2",
          attrs: {
            "fab": "fab",
            "x-small": "x-small",
            "disabled": _vm.indexTipoListadoReportes === 1
          },
          on: {
            "click": function($event) {
              return _vm.editarRowFiltrosAvanzados(index)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")])], 1), _c('v-btn', {
          attrs: {
            "fab": "fab",
            "x-small": "x-small",
            "color": "primary",
            "disabled": _vm.indexTipoListadoReportes === 1
          },
          on: {
            "click": function($event) {
              return _vm.eliminarRowFiltrosAvanzados(index)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)]
      }
    }, {
      key: "item.condicion",
      fn: function(ref) {
        var item = ref.item;

        return [_c('strong', [_vm._v(_vm._s(item.condicion.name))])]
      }
    }], null, false, 496348782)
  })] : _vm._e()], 2), _c('div', {
    staticClass: "d-flex pa-4 border-top"
  }, [_c('div', {
    staticClass: "flex-1"
  }), _c('div', {
    staticClass: "flex-1 jc-end d-flex"
  }, [_c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.goToPrevisualizarReporte()
      }
    }
  }, [(_vm.idReporteSeleccionado !== '') ? _c('span', [_vm._v("Previsualizar")]) : _c('span', [_vm._v("Ver datos borrador")])]), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "success",
      "disabled": _vm.indexTipoListadoReportes === 1
    },
    on: {
      "click": function($event) {
        return _vm.verificarSiEsReporteNuevo()
      }
    }
  }, [(_vm.idReporteSeleccionado !== '') ? _c('span', [_vm._v("Guardar cambios")]) : _c('span', [_vm._v("Guardar datos")])])], 1)])], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-daab5dfc","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_reportes.vue
// module id = 529
// module chunks = 1